import React from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

import { selectCurrentUser } from 'store/users/users.selectors'

import { UserData } from 'components/organisms/AdminBody/Users/hook/use-user'
import { UserRole } from 'types/user'
import classes from './style.module.css'

interface UserListProps {
  users: UserData[]
  onClick(user: UserData): void
}

export const UserList: React.FC<UserListProps> = ({ users, onClick }) => {
  const currentUser = useSelector(selectCurrentUser)
  return (
    <div className={classNames('list-group row', classes.container)}>
      {users.map((user) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <div className={classNames('list-group-item list-group-item-action', classes.user)} key={user!.id} onClick={() => onClick(user)}>
          <span>
            Логин: <span className="font-weight-bold">{user.login}</span>
          </span>
          <br />
          <span>Имя: {user.name}</span>
          <br />
          {currentUser?.role === UserRole.CUSTOMER ? (
            <span>Роль: {user.features?.subrole === 'customer-admin' ? 'Администратор' : 'Сотрудник'}</span>
          ) : (
            <span>Роль: {user.role}</span>
          )}
          <br />
          <span />
          Статус: {user.features?.isUserDeactivated ? 'Отключён' : 'Активен'}
        </div>
      ))}
    </div>
  )
}

export default UserList
